/**
 * finTasksAIService
 * Frontend helpers for AI task assistance endpoints.
 * All functions are READ-ONLY assistance; they never mutate tasks automatically.
 */
import { apiClient } from './api';

export async function prioritiseTasks({ userId, tasks, timeWindow = 'today' }) {
  // apiClient.post already returns response.data, no need to destructure
  const data = await apiClient.post('/ai/tasks/prioritise', { userId, tasks, timeWindow });
  return data; // { ordered: [{ taskId, priorityScore, reason }], meta }
}

export async function tasksFromSpending({ userId }) {
  const data = await apiClient.post('/ai/tasks/from-spending', { userId });
  return data; // { drafts, meta }
}

export async function goalLinkExplanation({ task, goalId }) {
  const data = await apiClient.post('/ai/tasks/goal-link', { task, goalId });
  return data; // { explanation }
}
